// ------------------------------------------------------------------------------
// name: light
// author: mudas
// created: 2024/12/9
// ------------------------------------------------------------------------------

import { ThemeConfig } from '@fuxi/eevee-ui';

export const LightTheme: NonNullable<ThemeConfig['token']> = {
  colorText: 'rgb(1, 3, 22, 0.88)',
  colorTextLightSolid: 'rgba(255,255,255,1)',
  colorTextHeading: 'rgba(1, 3, 22, 0.88)',
  colorTextSecondary: 'rgba(1, 3, 22, 0.65)',
  colorTextLabel: 'rgba(1, 3, 22, 0.65)',
  colorTextTertiary: 'rgba(1, 3, 22, 0.45)',
  colorTextDescription: 'rgba(1, 3, 22, 0.45)',
  colorTextQuaternary: 'rgba(1, 3, 22, 0.25)',
  colorTextPlaceholder: 'rgba(1, 3, 22, 0.25)',
  colorBgContainer: '#ffffff',
  colorBgContainerDisabled: 'rgba(0, 0, 0, 0.04)',
  colorBgElevated: '#ffffff',
  controlItemBgHover: 'rgba(0, 0, 0, 0.04)',
  colorBgLayout: '#f5f7fa',
  colorBgMask: 'rgba(255, 255, 255, 0.6)',
  colorBgSpotlight: 'rgba(0, 0, 0, 0.85)',
  colorBgTextActive: 'rgba(0, 0, 0, 0.18)',
  colorBgTextHover: 'rgba(0, 0, 0, 0.08)',
  colorBgBase: '#ffffff',
  colorBorderBg: '#ffffff',
  colorBorder: '#d9d9d9',
  colorBorderSecondary: '#f0f0f0',
  colorSplit: 'rgba(0, 0, 0, 0.08)',
  colorFill: 'rgba(1, 3, 22, 0.15)',
  colorFillSecondary: 'rgba(1, 3, 22, 0.06)',
  colorFillTertiary: 'rgba(1, 3, 22, 0.04)',
  colorFillQuaternary: 'rgba(1, 3, 22, 0.02)',

  colorFillContent: 'rgba(1, 3, 22, 0.06)',
  colorFillContentHover: 'rgba(1, 3, 22, 0.15)',
  colorFillAlter: 'rgba(1, 3, 22, 0.02)',
  colorPrimary: '#4f5bff',
  colorInfo: '#4f5bff',
  colorInfoBg: '#f0f3ff',
  colorPrimaryBg: '#f0f3ff',

  colorSuccess: '#00ba55',
  colorError: '#f34d71',
  colorWarning: '#fa8a16',
  colorSuccessBg: '#e1fae8',
  colorWarningBg: '#fff7e6',
  colorErrorBg: '#fff0f0',
  colorPrimaryHover: '#7885ff',
  colorLinkHover: '#7885ff',
  colorLink: '#4f5bff',

  boxShadow: '0 1px 2px 0px rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0px rgba(0, 0, 0, 0.02)',
  boxShadowSecondary:
    '0 6px 16px 0px rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.02), 0 2px 4px 0px rgba(0, 0, 0, 0.02)',

  // padding&margin
  padding: 16,
  paddingXXS: 4,
  paddingXS: 8,
  paddingSM: 12,
  paddingMD: 20,
  paddingLG: 24,
  paddingXL: 32,

  margin: 16,
  marginXXS: 4,
  marginXS: 8,
  marginSM: 12,
  marginLG: 24,
  marginXL: 32,
  marginXXL: 48,
  // height
  controlHeight: 32,
  controlHeightXS: 16,
  controlHeightSM: 24,
  controlHeightLG: 48,
  // border
  borderRadiusXS: 2,
  borderRadiusSM: 6,
  borderRadius: 8,
  borderRadiusLG: 10,
  borderRadiusOuter: 6,
};
